import * as joint from '@joint/core'
import RappidContext from '../rappid/rappid-context'
import { useArtifactCacheStore } from '@/stores/artifactCacheStore'
import {
  CONTAINER_HEADER_HEIGHT,
  ARTIFACT_ROW_HEIGHT,
  MAX_VISIBLE_ARTIFACTS,
  CONTAINER_BOTTOM_PADDING,
} from '../rappid/layout-constants'

/**
 * Pure utility functions for collapsing/expanding containers
 * These can be used from both Vue composables and plain classes
 */

export function collapseContainer(
  cell: joint.dia.CellView | joint.dia.Cell,
  _rappidContext: RappidContext,
): void {
  let container = cell as any
  if (container.model) {
    container = container.model
  }

  // Hide search, link coverage bar, and artifact list (count badge stays visible)
  container.attr('search/visibility', 'hidden')
  container.attr('linkCoverageBar/visibility', 'hidden')
  container.attr('artifactList/visibility', 'hidden')

  container.resize(container.attributes.original_width, container.attributes.original_height)
  container.set('collapsed', true)
}

export function expandContainer(
  cell: joint.dia.CellView | joint.dia.Cell,
  _rappidContext: RappidContext,
): void {
  let container = cell as any
  if (container.model) {
    container = container.model
  }

  // Show search, link coverage bar, and artifact list (count badge stays visible)
  container.attr('search/visibility', 'visible')
  container.attr('linkCoverageBar/visibility', 'visible')
  container.attr('artifactList/visibility', 'visible')

  // Calculate container height based on artifact count
  const artifactType = container.prop('artifactType')
  const artifactCacheStore = useArtifactCacheStore()

  let artifactCount = 0
  if (artifactType) {
    artifactCount = artifactCacheStore.artifactsByType.get(artifactType.id)?.length ?? 0
  }

  // Calculate height: header + visible artifacts (capped at MAX_VISIBLE_ARTIFACTS)
  const visibleCount = Math.min(Math.max(artifactCount, 1), MAX_VISIBLE_ARTIFACTS)
  const artifactAreaHeight = visibleCount * ARTIFACT_ROW_HEIGHT
  const newHeight = CONTAINER_HEADER_HEIGHT + artifactAreaHeight + CONTAINER_BOTTOM_PADDING

  container.resize(container.attributes.original_width, newHeight)
  container.set('collapsed', false)
}
